/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Grid, { GridProps } from '@mui/material/Grid';

type AllowedGridProps = Pick<
  GridProps,
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'spacing'
  | 'direction'
  | 'justifyContent'
  | 'alignItems'
  | 'wrap'
  | 'style'
  | 'sx'
>;

interface GridContainerProps extends AllowedGridProps {
  children?: React.ReactNode;
}

function GridContainer({
  children,
  sx,
  xs,
  sm,
  md,
  lg,
  xl,
  spacing,
  direction,
  justifyContent,
  alignItems,
  wrap,
  style,
}: GridContainerProps) {
  return (
    <Grid
      container
      sx={sx}
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      spacing={spacing}
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      wrap={wrap}
      style={style}
    >
      {children}
    </Grid>
  );
}

export default GridContainer;
